export default {
  app: {
    connectionIssues: "[FE] Internet bilan bog'liq muammolar bo'lishi mumkin!",
    loginAgainRequired: '[FE] Saytga qaytadan kirish kerak',
    unknownError: '[FE] Noma’lum xato',
    appErrors: '[FE] Sayt bilan muammolar',
  },
};
